import "../Navbar/Navbar.css";
import { useState } from "react";
import { Link } from "react-router-dom";
import { NavHashLink } from "react-router-hash-link";

const Navbar = () => {
  const [show, setShow] = useState(false);

  return (
    <>
      <header>
        <div className="head-container">
          <div className="Logo-container ">
            {" "}
            <Link to="/">Shahfolio</Link>
          </div>
          <div className="menu-items">
            <NavHashLink smooth to="/#Home-Section">
              Home
            </NavHashLink>
            <NavHashLink smooth to="/#projects">
              Projects
            </NavHashLink>
            <NavHashLink smooth to="/#services">
              Services
            </NavHashLink>
            <NavHashLink smooth to="/#about">
              About
            </NavHashLink>
            <Link to="/contact">Contact</Link>
          </div>
          <button
            className={`hamburger ${show ? "is-active" : ""}`}
            onClick={(e) => {
              setShow(!show);
            }}
          >
            <div className="bar"></div>
          </button>
        </div>
      </header>

      <nav className={`mobile-nav ${show ? "is-active" : ""} `}>
        <Link to="/">Home</Link>
        <NavHashLink smooth to="/#about">
          About
        </NavHashLink>
        <NavHashLink smooth to="/#services">
          Services
        </NavHashLink>
        <NavHashLink to="/contact/#contact">Contact</NavHashLink>
      </nav>
    </>
  );
};

export default Navbar;
